import { useState } from "react";
import Container from "../../../../components/container";
import IconButton from "../../../../components/icon-button";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { CharityEventType } from "../../../../models";
import CharityEventTypeCreateForm from "./charity-event-type-create-form";
import CharityEventTypeUpdateRow from "./charity-event-type-update-row";
import { DeleteCharityEventTypeButton } from "./buttons";

export default function CharityEventTypesTable({
  items,
  loading,
  onChanged,
}: {
  items: CharityEventType[];
  loading: boolean;
  onChanged: () => void;
}) {
  const [editing, setEditing] = useState<CharityEventType>();

  if (loading) {
    return (
      <Container className=" max-w-xl">
        <div className="rounded-md bg-white p-4">Loading...</div>
      </Container>
    );
  }

  return (
    <Container className=" max-w-xl">
      <table className="min-w-full text-gray-900 text-left">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {items.map((item) => (
            <tr key={item.id} className="border-b">
              {editing?.id === item.id ? (
                <CharityEventTypeUpdateRow
                  item={item}
                  onCancel={() => setEditing(undefined)}
                  onChanged={onChanged}
                />
              ) : (
                <>
                  <td className="px-6 py-4 font-medium">{item.name}</td>
                  <td className="px-6 py-4">
                    {item.id ? (
                      <div className="flex items-center justify-end gap-2">
                        <IconButton label="Edit" icon={PencilSquareIcon} onClick={() => setEditing(item)} />
                        <DeleteCharityEventTypeButton item={item} onChanged={onChanged} />
                      </div>
                    ) : null}
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={2} className="px-6 py-4">
              <CharityEventTypeCreateForm onChanged={onChanged} />
            </td>
          </tr>
        </tfoot>
      </table>
    </Container>
  );
}
